import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {
  getAll,
  getId,
  createItem,
  updateItem,
  deleteById,
  changeItem,
  resetItem,
  getAllCompany,
  uploadItemValidate,
  upload,
  getVersion,
  createApk,
} from "./userAPI";

const initialState = {
  data: [],
  dataCompany: [],
  dataId: null,
  loading: false,
  error: null,
  pageNo: 1,
  pageSize: 10,
  totalRecord: 0,
  selected: null,
  result: null,
};

export const fetchData = createAsyncThunk("user/fetchData", async (payload) => {
  const response = await getAll(payload);
  return response;
});

export const fetchVersion = createAsyncThunk(
  "apk/fetchVersion",
  async (payload) => {
    const response = await getVersion(payload);
    return response;
  }
);

export const fetchDataAllCompany = createAsyncThunk(
  "user/fetchDataAllCompany",
  async (payload) => {
    const response = await getAllCompany(payload);
    return response;
  }
);

export const fetchUser = createAsyncThunk("user/fetchUser", async (payload) => {
  const response = await getAll(payload);
  return response;
});

export const fetchId = createAsyncThunk("user/fetchId", async (id) => {
  const response = await getId(id);
  return response;
});
export const fetchIdNoloading = createAsyncThunk(
  "user/fetchIdNoloading",
  async (id) => {
    const response = await getId(id);
    return response;
  }
);

export const addItem = createAsyncThunk("user/addItem", async (payload) => {
  const response = await createItem(payload);
  return response;
});

export const downloadApk = createAsyncThunk("apk/download", async (payload) => {
  const response = await createApk(payload);
  return response;
});

export const resetPassword = createAsyncThunk(
  "user/resetPassword",
  async (payload) => {
    const response = await resetItem(payload);
    return response;
  }
);
export const changePassword = createAsyncThunk(
  "user/changePassword",
  async (payload) => {
    const response = await changeItem(payload);
    return response;
  }
);

export const editItem = createAsyncThunk("user/editItem", async (payload) => {
  const response = await updateItem(payload);
  return response;
});
export const removeById = createAsyncThunk(
  "user/removeById",
  async (payload) => {
    const response = await deleteById(payload);
    return response;
  }
);

export const uploadValidate = createAsyncThunk(
  "user/uploadValidate",
  async (payload) => {
    const response = await uploadItemValidate(payload);
    return response;
  }
);
export const uploadItem = createAsyncThunk(
  "user/uploadItem",
  async (payload) => {
    const response = await upload(payload);
    return response;
  }
);

export const userSlice = createSlice({
  name: "user",
  initialState,
  reducers: {
    resetData: () => initialState,
    setSelected: (state, action) => {
      state.selected = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchData.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchData.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload.data.data;
        state.pageNo = action.payload.data.pageNo;
        state.pageSize = action.payload.data.pageSize;
        state.totalRecord = action.payload.data.totalRecords;
      })
      .addCase(fetchDataAllCompany.pending, (state) => {
        state.loading = false;
      })
      .addCase(fetchDataAllCompany.fulfilled, (state, action) => {
        state.loading = false;
        state.dataCompany = action.payload.data.data;
      })
      .addCase(fetchUser.pending, (state) => {
        state.loading = false;
      })
      .addCase(fetchUser.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload.data.data;
        state.pageNo = action.payload.data.pageNo;
        state.pageSize = action.payload.data.pageSize;
        state.totalRecord = action.payload.data.totalRecords;
      })
      .addCase(fetchId.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchId.fulfilled, (state, action) => {
        state.loading = false;
        state.dataId = action.payload.data.data;
      })
      .addCase(fetchIdNoloading.pending, (state) => {
        state.loading = false;
      })
      .addCase(fetchIdNoloading.fulfilled, (state, action) => {
        state.loading = false;
        state.dataId = action.payload.data.data;
      })
      .addCase(addItem.pending, (state) => {
        state.loading = true;
      })
      .addCase(addItem.fulfilled, (state, action) => {
        state.loading = false;
        state.result = action.payload;
      })
      .addCase(editItem.pending, (state) => {
        state.loading = true;
      })
      .addCase(editItem.fulfilled, (state, action) => {
        state.loading = false;
        state.result = action.payload;
      })
      .addCase(removeById.pending, (state) => {
        state.loading = true;
      })
      .addCase(removeById.fulfilled, (state, action) => {
        state.loading = false;
        state.result = action.payload;
      })
      .addCase(resetPassword.pending, (state) => {
        state.loading = true;
      })
      .addCase(resetPassword.fulfilled, (state, action) => {
        state.loading = false;
        state.result = action.payload;
      })
      .addCase(changePassword.pending, (state) => {
        state.loading = true;
      })
      .addCase(changePassword.fulfilled, (state, action) => {
        state.loading = false;
        state.result = action.payload;
      })
      .addCase(uploadItem.pending, (state) => {
        state.loading = true;
      })
      .addCase(uploadItem.fulfilled, (state, action) => {
        state.loading = false;
        state.result = action.payload;
      })
      .addCase(uploadValidate.pending, (state) => {
        state.loading = true;
      })
      .addCase(uploadValidate.fulfilled, (state, action) => {
        state.loading = false;
        state.result = action.payload;
      })
      .addCase(fetchVersion.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchVersion.fulfilled, (state, action) => {
        state.loading = false;
        state.result = action.payload;
      })
      .addCase(downloadApk.pending, (state) => {
        state.loading = true;
      })
      .addCase(downloadApk.fulfilled, (state, action) => {
        state.loading = false;
        state.result = action.payload;
      });
  },
});

export const { resetData, setSelected } = userSlice.actions;

export const selectData = (state) => state.user.data;
export const selectDataUser = (state) => state.user.data;
export const selectDataAllCompany = (state) => state.user.dataCompany;
export const selectId = (state) => state.user.dataId;
export const selectLoading = (state) => state.user.loading;
export const selectError = (state) => state.user.error;
export const selectPageNo = (state) => state.user.pageNo;
export const selectPageSize = (state) => state.user.pageSize;
export const selectTotalRecord = (state) => state.user.totalRecord;
export const selectSelected = (state) => state.user.selected;
export const selectResult = (state) => state.user.result;

export default userSlice.reducer;
